// src/components/LogoUrlRestorer.js
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { restoreLogoUrl } from '../utils/logoSlice'
import { useLocation } from 'react-router-dom';

const LogoUrlRestorer = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    dispatch(restoreLogoUrl());
  }, [location.pathname, dispatch]);

  return null;
};

export default LogoUrlRestorer;